"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polygons = void 0;
var Polygons = /** @class */ (function () {
    function Polygons() {
        // property
        this.array = [];
    }
    // method
    Polygons.prototype.clear = function () {
        this.array = [];
    };
    Polygons.prototype.push = function (polygon) {
        // only a simple check
        var minx = 200;
        var maxx = 0;
        var miny = 200;
        var maxy = 0;
        if (polygon.length < 3) {
            return;
        }
        for (var _i = 0, _a = polygon.array; _i < _a.length; _i++) {
            var _b = _a[_i], x = _b.x, y = _b.y;
            if (x < minx) {
                minx = x;
            }
            if (x > maxx) {
                maxx = x;
            }
            if (y < miny) {
                miny = y;
            }
            if (y > maxy) {
                maxy = y;
            }
            if (isNaN(x) || isNaN(y)) {
                return;
            }
        }
        if (minx !== maxx && miny !== maxy) {
            this.array.push(polygon);
        }
    };
    Polygons.prototype.generateSVG = function (curve) {
        var buffer = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" '
            + 'version="1.1" baseProfile="full" viewBox="0 0 200 200" width="200" height="200">\n';
        if (curve) {
            this.array.forEach(function (_a) {
                var array = _a.array;
                var mode = "L";
                buffer += '<path d="';
                for (var j = 0; j < array.length; j++) {
                    if (j === 0) {
                        buffer += "M ";
                    }
                    else if (array[j].off) {
                        buffer += "Q ";
                        mode = "Q";
                    }
                    else if (mode === "Q" && !array[j - 1].off) {
                        buffer += "L ";
                    }
                    else if (mode === "L" && j === 1) {
                        buffer += "L ";
                    }
                    buffer += array[j].x + "," + array[j].y + " ";
                }
                buffer += 'Z" fill="black" />\n';
            });
        }
        else {
            buffer += '<g fill="black">\n';
            buffer += this.array.map(function (_a) {
                var array = _a.array;
                return "<polygon points=\"" + array.map(function (_a) {
                    var x = _a.x, y = _a.y;
                    return x + "," + y + " ";
                }).join("") + "\" />\n";
            }).join("");
            buffer += "</g>\n";
        }
        buffer += "</svg>\n";
        return buffer;
    };
    Polygons.prototype.generateEPS = function () {
        var buffer = "";
        buffer += "%!PS-Adobe-3.0 EPSF-3.0\n%%BoundingBox: 0 -208 1024 816\n%%Pages: 0\n%%Title: Kanji glyph\n%%Creator: GlyphWiki powered by KAGE system\n%%CreationDate: " + new Date().toString() + "\n%%EndComments\n%%EndProlog\n";
        this.array.forEach(function (_a) {
            var array = _a.array;
            for (var j = 0; j < array.length; j++) {
                buffer += array[j].x * 5 + " " + (1000 - array[j].y * 5 - 200) + " ";
                if (j === 0) {
                    buffer += "newpath\nmoveto\n";
                }
                else {
                    buffer += "lineto\n";
                }
            }
            buffer += "closepath\nfill\n";
        });
        buffer += "%%EOF\n";
        return buffer;
    };
    return Polygons;
}());
exports.Polygons = Polygons;
